<!-- 写回答页面 -->
<template>
    <div class="write-answer">
        <div class="answer-card">
            <div class="header">
                <div class="left">
                    <veui-button
                        ui="text" class="go-back"
                        @click="goBack"
                    >
                        返回
                    </veui-button>
                    <div class="vertical-line"></div>
                    <div class="title">写回答</div>
                </div>
            </div>
            <div class="line"></div>
            <section>
                <div class="ques-title">{{ quesInfo.question }}</div>
                <div
                    ref="editorWrapper"
                    class="editor-wrapper"
                    :style="{height: editorHeight + 'px'}"
                    >
                    <div
                        v-if="isAiContent && showAiContentTip"
                        class="ai-tip"
                    >
                        <span class="ai-tip-icon"></span>
                        AI为您生成如下内容，仅供参考，不能代替专业法律意见，请您酌情使用，确保不侵犯他人合法权益。
                        <span
                            class="close-icon"
                            @click="handleAiContentTip"
                        ></span>
                    </div>
                    <div
                        class="editor"
                        :class="{'error': isShowLengthError, 'is-ai-content': isAiContent && showAiContentTip}"
                    >
                        <customize-editor
                            ref="editor"
                            :quill-id="0"
                            :quill-toolbar="quillToolbar"
                            external-class="write-answer-editor"
                            :quill-placeholder="''"
                            :upload-url="url"
                            :is-default-upload="false"
                            @editor-change="handleEditorChange"
                            @editor-focus="isEditerFocus = true"
                        >
                        </customize-editor>
                        <div
                            v-if="isAiPlaceholder"
                            class="loader"
                            :style="{top: isAiContent && showAiContentTip ? '113px' : '57px'}"
                        >
                            <span class="aiplaceholder">请稍后，内容加载中</span>
                            <div class="loader-dot"></div>
                            <div class="loader-dot"></div>
                            <div class="loader-dot"></div>
                        </div>
                        <div
                            v-else-if="!isEditerFocus"
                            class="loader"
                            :style="{top: isAiContent && showAiContentTip ? '113px' : '57px'}"
                        >
                            <span class="aiplaceholder">请输入回答</span>
                        </div>
                        <div class="count-bar">
                            <span
                                class="tip"
                            >内容字数请控制在{{ minLength }}-{{
                                maxLength
                            }}字以内
                            </span>
                            <span class="length">{{ textLength }}</span>/{{ maxLength }}
                        </div>
                    </div>
                    <div class="guide">
                        <div class="guide-header">
                            <div class="header-left">回答展示位置</div>
                            <div
                                v-if="exampleList.length"
                                class="header-right"
                                @click="clickExample"
                            >回答范例</div>
                        </div>
                        <div
                            class="guide-container"
                            :style="{height: (editorHeight - 46) + 'px'}"
                        >
                            <div class="case-img"></div>
                        </div>
                    </div>
                </div>
            </section>
            <!-- 预览图片 -->
            <div v-if="isPicPreview">
                <picReview
                    :pic="previewPic"
                    @closePreview="isPicPreview = false"
                />
            </div>
            <veui-dialog
                overlay-class="example-dialog"
                :open.sync="isShowExample"
                closable
                :footless="false"
                @cancel="isShowExample = false"
            >
                <div slot="title">
                    回答范例(<span class="blue">{{
                        curExample + 1
                    }}</span>/{{ exampleList.length }})
                </div>
                <!--bca-disable-->
                <div
                    class="example-content"
                    v-html="exampleList[curExample]"
                ></div>
                <!--bca-disable-->
                <div
                    slot="foot"
                    class="operation"
                >
                    <div class="operation-container">
                        <div
                            class="button-pre"
                            :class="curExample === 0 ? 'disabled' : ''"
                            @click="nextExample(-1)"
                        >
                            <span class="icon"></span>
                            <span class="text">上一个</span>
                        </div>
                        <div
                            class="button-next"
                            :class="
                                curExample === exampleList.length - 1
                                    ? 'disabled'
                                    : ''
                            "
                            @click="nextExample(1)"
                        >
                            <span class="text">下一个</span>
                            <span class="icon"></span>
                        </div>
                    </div>
                </div>
            </veui-dialog>
            <veui-dialog
                overlay-class="confirm-dialog"
                title="确认发布该回答吗？"
                :open.sync="isShowSubmitConfirm"
                closable
                @ok="submit"
                @cancel="handleCancelSubmitConfirm"
            >
                <p>
                    发布后该内容将于您的律师主页与搜索结果中展现，成为您专业性与权威性最好的证明
                </p>
            </veui-dialog>
            <veui-dialog
                overlay-class="confirm-dialog"
                title="确认放弃当前内容吗？"
                :open.sync="isShowConfirm"
                closable
                @ok="goBack"
                @cancel="isShowConfirm = false"
            >
                <p>
                    确认返回后，当前编辑的内容将全部消失，平台不回储存您的回答，请谨慎选择～
                </p>
            </veui-dialog>
            <veui-dialog
                overlay-class="confirm-dialog"
                title="恭喜您，已成功提交审核"
                :open.sync="isShowSuccessConfirm"
                :closable="false"
                :footless="false"
            >
                <p>
                    审核通过后即可正式发布，获取海量曝光、领取赠送线索，审核结果预计于2小时后产出。
                </p>
                <div
                    slot="foot"
                    class="operation"
                >
                    <div
                        class="confirm-button"
                        @click="handleShowSuccessConfirm"
                    >确认</div>
                </div>
            </veui-dialog>
        </div>
        <div ref="footer" class="footer">
            <veui-button
                ui="primary"
                class="submit-button"
                :class="
                content !== quesInfo.reply_content && isInLengthLimit
                    ? ''
                    : 'disabled'
            "
                :loading="isLoading"
                @click="handleSubmitClick"
            >
                发布
            </veui-button>
        </div>
        <veui-dialog
            ui="narrow"
            title="回答涉及敏感词，请修改"
            :open.sync="showFailDialog"
            overlay-class="fail-dialog"
        >
            <p class="fail-msg">您的回答涉及敏感词，请修改后提交，包括：{{ sensitiveWords }}</p>
            <template #foot>
                <veui-button
                    ui="m primary"
                    @click="closeDialog"
                >
                    去修改
                </veui-button>
            </template>
        </veui-dialog>
    </div>
</template>

<script>
/**
 * @file write-answer.vue
 * @desc 写回答组件
 * @author dingzhenyue@baidu.com
 */
import {Button, ConfirmBox, Dialog} from 'veui';
import CustomizeEditor from '@/components/customize-editor';
import picReview from '@/components/picReview.vue';
import {answerExamples} from '../utils';
export default {
    name: 'write-answer',
    components: {
        'veui-button': Button,
        CustomizeEditor,
        picReview,
        'veui-confirm-box': ConfirmBox,
        'veui-dialog': Dialog
    },
    props: {
        // 问题的信息
        quesInfo: {
            type: Object,
            default: () => {}
        },
        consumeType: {
            type: String,
            default: ''
        }
    },
    watch: {
        quesInfo: {
            handler(val) {
                if (!val.current_pre_dispatch_times) {
                    this.$wywLog.send({
                        serverId: 18574,
                        action: 'show',
                        area: 'answer_tip'
                    });
                }
            },
            immediate: true
        }
    },
    data() {
        return {
            quillToolbar: [
                ['bold', 'italic', 'underline'],
                [{header: 1}, {header: 2}, 'blockquote'],
                [{list: 'ordered'}, {list: 'bullet'}],
                [
                    {indent: '-1'},
                    {indent: '+1'},
                    {direction: 'rtl'},
                    {align: []}
                ],
                ['link', 'image']
            ],
            // 是否折叠
            isFold: true,
            // 是否图片预览
            isPicPreview: false,
            // 预览图片
            previewPic:
                'https://midpf-mp-pub.cdn.bcebos.com/908879662890c9c0a499e44cb6b6bf82.jpeg',
            // 是否展示提交确认弹框
            isShowSubmitConfirm: false,
            // 是否展示取消确认弹框
            isShowConfirm: false,
            // 图片上传链接
            url: '/bp/api/uploadIknowPic?ajax=1&bdstoken=',
            // 提交中
            isLoading: false,
            // 提交失败弹窗
            showFailDialog: false,
            // 敏感词
            sensitiveWords: '',
             // 示例
            exampleList: answerExamples,
            curExample: 0,
            editorHeight: 0,
            // 字数限制
            textLength: 0,
            minLength: 200,
            maxLength: 10000,
            // 字数错误提示
            isShowLengthError: false,
            // 回答内容
            content: '',
            isAiContent: true,
            showAiContentTip: true,
            isShowExample: false, // 是否展示示例
            isShowSuccessConfirm: false, // 是否展示提交成功弹框
            placeholder: '请输入回答',
            isAiPlaceholder: true,
            eventSource: '',
            index: 0,
            isEditerFocus: false,
            hasAiContent: false
        };
    },
    computed: {
        // 是否在字数限制区间
        isInLengthLimit() {
            const isInLengthLimit
                = this.textLength >= this.minLength
                    && this.textLength <= this.maxLength;
            // 如果在字数限制区间，则取消错误提示
            if (isInLengthLimit) {
                this.isShowLengthError = false;
            }
            return isInLengthLimit;
        }
    },
    mounted() {
        // 计算区域高度
        this.$nextTick(() => {
                this.editorHeight
                    = this.$refs.footer?.offsetTop
                        - this.$refs.editorWrapper?.offsetTop;
            });
        // 写回答曝光打点
        this.$log && this.$log.send({
            type: 'show',
            value: 'write-answer-pv'
        });
        this.getAiInfo();
    },
    beforeDestroy() {
        this.eventSource.close();
    },
    methods: {
        /**
         * 答案填写完成，返回主页面
         */

        goBack() {
            this.$emit('closeWriteCard');
        },

        /**
         * 点击预览
         */

        showModal() {
            this.isPicPreview = true;
        },
        // 示例翻页
        nextExample(add = 1) {
            const next = this.curExample + add;
            const canMove = next >= 0 && next < this.exampleList.length;
            this.$wywLog.send({
                serverId: 18827,
                action: 'click',
                area: add === 1 ? 'hdfl-next' : 'hdfl-back',
                index: +canMove
            });
            if (canMove) {
                this.curExample = next;
                this.$refs['guide-scroll-container']?.scrollTo({top: 0});
            }
        },
        handleCancelSubmitConfirm() {
            this.isShowSubmitConfirm = false;
        },
        handleShowSuccessConfirm() {
            this.isShowSubmitConfirm = false;
        },
        handleSubmitClick() {
            const {
                quesInfo,
                content,
                textLength,
                isInLengthLimit,
                maxLength,
                minLength
            } = this;
            if (!textLength) {
                this.$toast.error('请填写回答');
                // 发布按钮打点
                this.$wywLog.send({
                    serverId: 18827,
                    action: 'click',
                    area: 'fb-btn',
                    index: 0
                });
                return;
            }
            if (content === quesInfo.reply_content) {
                this.$toast.error('您的回答暂无任何修改');
                // 发布按钮打点
                this.$wywLog.send({
                    serverId: 18827,
                    action: 'click',
                    area: 'fb-btn',
                    index: 0
                });
                return;
            }
            if (!isInLengthLimit) {
                this.$toast.error(`请限制字数在${minLength}~${maxLength}之间`);
                this.isShowLengthError = true;
                // 发布按钮打点
                this.$wywLog.send({
                    serverId: 18827,
                    action: 'click',
                    area: 'fb-btn',
                    index: 0
                });
                return;
            }
            this.isShowSubmitConfirm = true;
        },
        /**
         * 点击发布提交
         */

        submit() {
            let content = this.$refs.editor?.content || '';
            // 写回答打点
            this.$log
                && this.$log.send({
                    type: 'clk',
                    value: 'write-submit'
                });
            if (!content) {
                this.$toast.error('请填写回答');
                return;
            }
            if (content.includes('</a>')) {
                let arr = content.split('<a ');
                arr.forEach((element, index) => {
                    if (index) {
                        arr[index] = 'class="iknow-ueditor-link" title="" ' + arr[index];
                    }
                });
                content = arr.join('<a ');
            }
            // 提交
            this.postData(content);
        },
        handleAiContentTip() {
            this.showAiContentTip = false;
        },
        /**
         * 提交回答
         * @param {String} content 输入的回答
         */

        postData(content) {
            if (this.isLoading) {
                return;
            }
            this.isLoading = true;
            // 写回答打点
            this.$log && this.$log.send({
                type: 'clk',
                value: 'post-data'
            });
            this.$http
                .post('/bp/api/offqr/reply', {
                    content,
                    clue_id: this.quesInfo?.clue_id || '',
                    use_business: this.consumeType === '1'
                })
                .then(res => {
                    this.isLoading = false;
                    if (res && +res.code === 120005) {
                        this.$toast.error(res && res.msg || '咨询已被本律所律师回答');
                        return;
                    }
                    if (res && +res.code === 10005) {
                        let {hit_spam} = res.data;
                        this.sensitiveWords = hit_spam && Object.keys(hit_spam) && Object.keys(hit_spam).join('、');
                        this.showFailDialog = true;
                        this.$wywLog.send({
                            serverId: 18574,
                            action: 'show',
                            area: 'words'
                        });
                        return;
                    }
                    if (res && +res.code === 0) {
                        this.$toast.success('答案提交成功');
                        // 发布按钮打点
                        this.$wywLog.send({
                                serverId: 18827,
                                action: 'click',
                                area: 'fb-btn',
                                index: 1
                            });
                        this.isShowSuccessConfirm = false;
                        this.$emit('submitSuccess');
                        return;
                    }
                    this.$toast.error((res && res.msg) || '回答提交失败');
                })
                .catch(err => {
                    this.$normalizeResponseError(err);
                    this.isLoading = false;
                });
        },
        closeDialog() {
            this.showFailDialog = false;
            this.$wywLog.send({
                serverId: 18574,
                action: 'click',
                area: 'revise_btn'
            });
        },
        // 更新文本框中的内容，并记录文本长度
        handleEditorChange({innerHTML, length}) {
            this.textLength = length;
            this.content = innerHTML;
        },
        // 获取AI回答
        getAiInfo() {
            this.eventSource = new EventSource(`/bp/api/offqr/streamContentByClueId?query=${this.quesInfo.question}&clue_id=${this.quesInfo.clue_id}`, {});
                this.eventSource.onmessage = event => {
                    const message = JSON.parse(event.data)?.message || '';
                    this.isAiPlaceholder = false;
                    if (message !== 'end') {
                        this.$refs.editor?.insertText(this.index, message);
                        this.index += message.length;
                        this.isEditerFocus = true;
                        this.hasAiContent = true;
                    }
                    else {
                        // 初次返回end，表示没有ai回答，不展示ai提示
                        !this.hasAiContent && (this.isAiContent = false);
                        this.eventSource.close();
                    }
                };
                this.eventSource.onerror = () => {
                    this.isAiPlaceholder = false;
                    this.isAiContent = false;
                    this.eventSource.close();
                };
            },
        // 点击回答范例
        clickExample() {
            // 回答范例打点
            this.$wywLog.send({
                serverId: 18827,
                action: 'click',
                area: 'example'
            });
            this.isShowExample = true;
            // 回答范例弹窗曝光
            this.$wywLog.send({
                serverId: 18827,
                action: 'show',
                area: 'hdfl'
            });
        }
    }
};
</script>
<style lang='less' scoped>
.write-answer {
    height: 100%;
    overflow: hidden;
    position: relative;
    padding: 0 30px 0;
    background-color: #fff;
    .footer {
        height: 64px;
        display: flex;
        align-items: center;
        justify-content: center;
        box-shadow: 0 -1px 10px 0 rgba(0, 0, 0, .1);
        position: absolute;
        bottom: 0;
        left: 0;
        width: 100%;
        background: #fff;
        z-index: 1;

        button {
            height: 40px;
            width: 86px;
            border-radius: 5px;
        }

        .submit-button {
            padding: 0 29px;
            height: 36px;
            background: #0055ff;
            &.disabled {
                background: rgba(153, 153, 153, 0.5);
                cursor: default;
                color: #fff;
                border: 0;
            }
        }
    }
}
.answer-card {
    background: #fff;
    border-radius: 8px;
    padding-top: 38px;
    height: 100%;
    position: relative;
    width: 100%;
    overflow: auto;
    .header {
        display: flex;
        align-items: center;
        justify-content: space-between;
        font-family: PingFangSC-Regular;
        color: #333;
        .left {
            display: flex;
            align-items: center;
            justify-content: space-between;

            .go-back {
                position: relative;
                padding-left: 12px;

                &::before {
                    content: "";
                    position: absolute;
                    height: 12px;
                    width: 10px;
                    left: 0;
                    top: 50%;
                    transform: translateY(-50%);
                    background:
                        url(https://lvlin-base.cdn.bcebos.com/bend/back-icon.png)
                        no-repeat center center / 100% 100%;
                }
            }

            .vertical-line {
                height: 10px;
                width: 1px;
                background: #9d9d9d;
                margin: 0 10px;
            }

            /deep/ .veui-button,
            .title {
                font-size: 16px;
                line-height: 16px;
                font-weight: 400;
            }

            .tips {
                position: absolute;
                left: 156px;
                background: rgba(254, 217, 185, .5);
                border: 1px solid #4016110d;
                font-family: PingFang SC;
                font-size: 12px;
                font-weight: 400;
                line-height: 1;
                color: #401611;
                display: flex;
                align-items: center;
                justify-content: center;
                padding: 5px 8px;
                border-radius: 5px;

                .tips-icon {
                    height: 12px;
                    width: 12px;
                    margin-right: 4px;
                    background: url(https://lvlin-base.cdn.bcebos.com/fe-saas/page/law-clues/Frame%20192.png) no-repeat center center/100% 100%;
                }
            }
        }

        .tips-btn {
            font-size: 14px;
            color: #0052cc;
            line-height: 14px;
            font-weight: 400;
        }
    }

    .line {
        height: 1px;
        background: #e9ecf3;
        width: 100%;
        margin: 30px 0 20px;
    }

    .ques-title {
        color: #333333;
        text-align: justify;
        font-family: PingFangSC-Medium;
        font-size: 18px;
        line-height: 28px;
        font-weight: 500;
    }
    .editor-wrapper{
        margin-top: 20px;
        padding-bottom: 30px;
        display: flex;
        align-items: flex-start;
        position: relative;
        .ai-tip {
            position: absolute;
            display: flex;
            align-items: center;
            color: #1E1F24;
            font-size: 14px;
            width: 708px;
            height: 40px;
            background: linear-gradient(to left, rgba(126, 105, 255, 0.1) 0%, rgba(61, 117, 255, 0.1) 100%);
            top: 62px;
            left: 15px;
            border-radius: 6px;
            z-index: 99;

            .ai-tip-icon,
            .close-icon {
                display: inline-block;
                width: 16px;
                height: 16px;
            }

            .close-icon {
                position: absolute;
                right: 16px;
                background: url("https://lvlin-base.bj.bcebos.com/fe-saas/page/qa-manage/ai-tip-close.png") no-repeat center / 100%;
                &:hover {
                    cursor: pointer;
                }
            }

            .ai-tip-icon {
                margin: 0 8px 0 18px;
                background: url('https://lvlin-base.bj.bcebos.com/fe-saas/page/qa-manage/ai-tip-icon.png') no-repeat center / 100%;
            }
        }
        .editor {
            position: relative;
            width: 749px;
            height: 100%;
            .edit-container.write-answer-editor {
                width: 100%;
                height: 100%;
                /deep/.quill-editor.quill-editor-box {
                    height: 100%;
                }
                /deep/ .ql-toolbar.ql-snow {
                    border-radius: 1px 1px 0 0;
                    padding: 10px;
                }
                /deep/ .ql-container.ql-snow {
                    width: 100%;
                    height: calc(100% - 46px);
                    border-radius: 0 0 1px 1px;
                    padding-bottom: 46px;
                    .ql-editor {
                        font-size: 14px;
                    }
                }
            }
            &.is-ai-content {
                /deep/ .quill-editor-box {
                    .ql-container.ql-snow {
                        padding-top: 56px;
                    }
                }
            }
            .count-bar {
                width: 100%;
                height: 46px;
                position: absolute;
                bottom: 0;
                left: 0;
                padding: 12px 20px 20px;
                box-sizing: border-box;
                text-align: right;
                font-family: PingFangSC-Regular;
                font-size: 14px;
                color: #848691;
                line-height: 14px;

                .length {
                    color: #333333;
                }
            }
            &.error {
                .edit-container.write-answer-editor {
                    /deep/ .ql-toolbar.ql-snow {
                        border-color: #fd503e;
                    }
                    /deep/ .ql-container.ql-snow {
                        border-color: #fd503e;
                    }
                }
                .count-bar .tip {
                    color: #fd503e;
                }
            }
            /* 三个点的动画效果 */
            @keyframes bounce {
                0%, 80%, 100% {
                    transform: scale(0);
                    opacity: 0;
                }
                40% {
                    transform: scale(1);
                    opacity: 1;
                }
                }
            .loader {
                display: flex;
                justify-content: center;
                position: absolute;
                left: 15px;
                align-items: center;
                color: #333333;
                font-style : italic;
                .loader-dot {
                    background-color: #333333;
                    border-radius: 50%;
                    width: 3px;
                    height: 3px;
                    margin: 0 3px;
                    animation: bounce 1s infinite;
                    &:nth-child(1) {
                    animation-delay: 0.2s;
                    }
                    &:nth-child(2) {
                    animation-delay: 0.4s;
                    }
                    &:nth-child(3) {
                    animation-delay: 0.6s;
                    }
                }
            }
        }
        .guide {
                margin-left: 10px;
                padding: 0 12px;
                width: 308px;
                height: 100%;
                border: 1px solid #d1d1d1;
                border-radius: 1px;
                display: flex;
                flex-direction: column;
                .guide-header {
                    flex: 0 0 auto;
                    display: flex;
                    align-items: center;
                    justify-content: space-between;
                    height: 46px;
                    font-size: 16px;
                    line-height: 16px;
                    .header-left {
                        font-family: PingFangSC-Medium;
                        color: #1e1f24
                    }

                    .header-right {
                        font-family: PingFangSC-Regular;
                        color: #0055ff;
                        &:hover {
                            cursor: pointer;
                        }
                    }
                }
                .guide-container {
                    overflow: auto;
                    border: none;
                    position: relative;
                    -ms-overflow-style: none; /* IE and Edge */
                    scrollbar-width: none; /* Firefox */
                    &::-webkit-scrollbar {
                        display: none; /* Chrome, Safari and Opera */
                    }

                    .case-img {
                        position: absolute;
                        border-radius: 20px;
                        top: 0;
                        left: 0;
                        right: 0;
                        bottom: 0;
                        width: 282px;
                        height: 560px;
                        background-image: url('https://lvlin-base.bj.bcebos.com/fe-saas/page/qa-manage/show-lawyerCase.png');
                        background-repeat: no-repeat;
                        background-size: cover;
                    }
                }
            }
    }
}
.example-dialog {
    /deep/ .veui-dialog-content {
        padding-bottom: 12px;
        width: 600px;
        height: 530px;
        border-radius: 8px;
        .veui-dialog-content-head-title {
            font-family: PingFangSC;
            position: relative;
            left:16px;
            font-weight: 600;
            font-size: 20px;
            color: #000;
            display: inline-block;
            width: 100%;
            text-align: center;
        }

        .veui-dialog-content-body {
            .example-content {
                p {
                    line-height: 22px;

                    &:nth-child(2) {
                        line-height: 10px;

                    }
                }
            }
        }

        .veui-dialog-content-foot {
            border-top: 1px solid #E9ECF3;
            padding-top: 0px;
            .operation {
                display: flex;
                justify-content: center;
                width: 100%;
                height: 48px;
                position: relative;
                top:6px;
                .operation-container {
                    width: 270px;
                    display: flex;
                    justify-content: space-between;
                    .button-pre,
                    .button-next {
                        display: flex;
                        align-items: center;
                        cursor: pointer;
                        font-family: PingFangSC-Medium;
                        font-size: 14px;
                        color: #0055ff;
                        text-align: center;
                        line-height: 14px;
                        .icon {
                            width: 16px;
                            height: 16px;
                            background: url(https://lvlin-base.cdn.bcebos.com/fe-saas/page/qa-manage/next-icon.png)
                                no-repeat center center / cover;
                        }
                        .text {
                            margin: 0 7px;
                        }
                        &.disabled {
                            color: #999999;
                            .icon {
                                background-image: url(https://lvlin-base.cdn.bcebos.com/fe-saas/page/qa-manage/next-icon-grey.png);
                            }
                        }
                    }
                    .button-pre .icon {
                        transform: rotate(180deg);
                    }
                }
            }
        }
    }
}
.confirm-dialog {
    /deep/ .veui-dialog-content {
        width: 420px;
        border-radius: 8px;
        .veui-dialog-content-head {
            padding: 24px;
            position: relative;
            .veui-dialog-content-head-title {
                font-family: PingFangSC-Medium;
                font-size: 18px;
                color: #1e1f24;
            }
            .veui-dialog-content-head-close {
                position: absolute;
                top: 24px;
                right: 24px;
            }
        }
        .veui-dialog-content-body {
            padding: 0 24px;
            font-size: 16px;
            line-height: 24px;
            color: #1e1f24;
        }
        .veui-dialog-content-foot {
            padding: 24px 24px 0;
            display: flex;
            flex-direction: row-reverse;
            justify-content: center;
            .veui-button {
                font-size: 16px;
                padding: 0 24px;
                height: 40px;
                background: #0055ff;
            }
            .veui-button + .veui-button {
                font-size: 16px;
                margin: 0 24px 0 0;
                border: 1px solid #0055ff;
                background: #fff;
                color: #0055ff;
            }

            .operation {
                .confirm-button {
                    cursor: pointer;
                    width: 80px;
                    height: 40px;
                    background-color: #0055ff;
                    font-family: PingFangSC-Medium;
                    font-size: 16px;
                    line-height: 40px;
                    color: #fff;
                    text-align: center;
                    border-radius: 5px;
                }
            }
        }
    }
}
</style>
